<template>
  <nav 
    class="lb-right-panel" :class="{'zindex1':showObjectList}"
  >
    <div class="panel-block is-block">
      <div class="level mb-2 is-mobile">
        <div class="level-left">
          <div 
            v-if="!showComments&&!showChanges&&!showObjectList" 
            class="level-item"
          >
            <button
              v-t="'save'"
              :class="{ 'is-loading': saving }"
              :disabled="!hasChanges"
              class="button is-flat has-text-ocean-blue"
              @click="saveChanges"
            />
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <button
              v-t="'close'"
              class="button is-flat is-inverted has-text-dull-red"
              @click="$store.dispatch('Project/hideMenu')"
            />
          </div>
        </div>
      </div>
      <div class="lb-separator" />
    </div>
    <p 
      v-if="showConfiguration" 
      class="tabs is-centered"
    >
      <ul>
        <li :class="{ 'is-active': activeTab == 'INFORMATION' }">
          <a
            v-t="'projectConfiguration.basic_configuration_tab_title'"
            @click="activeTab = 'INFORMATION'"
          ></a>
        </li>
        <li
          v-if="$store.getters.isAdmin"
          :class="{ 'is-active': activeTab == 'LAYOUT' }"
          @click="activeTab = 'LAYOUT'"
        >
          <a v-t="'projectConfiguration.layout_tab_title'"></a>
        </li>
      </ul>
    </p>
    <div class="panel-block is-block">
      <project-configuration-privacy 
        v-if="showPrivacy" 
        v-model="project"
      />
      <project-configuration-changes 
        v-if="showChanges" 
        v-model="project"
        @openObject="$emit('openObject',$event)"
      />
      <project-configuration-comments 
        v-if="showComments" 
        :content-owner="project.owner"
        :object-id="project._id" 
        class="is-overflow-hidden"
      />
        
      <!--<project-configuration-participants 
        v-if="showParticipants" 
        :project="project"
      />-->

      <project-configuration-object-list 
        v-if="showObjectList"
        :items="items"
        @centerMap="$emit('centerMap',$event)"
      />
    </div>
  </nav>
</template>

<script>
import ProjectConfigurationFields from '@/components/ProjectConfigurationFields';
import ProjectConfigurationPrivacy from '@/components/ProjectConfigurationPrivacy';
import ProjectConfigurationChanges from '@/components/ProjectConfigurationChanges';
import ProjectConfigurationComments from '@/components/ProjectConfigurationComments';
//import ProjectConfigurationParticipants from "@/components/ProjectConfigurationParticipants";
import ProjectConfigurationObjectList from '@/components/ProjectConfigurationObjectList';
import _ from 'underscore';
export default {
    components: {
        ProjectConfigurationFields,
        ProjectConfigurationPrivacy,
        //ProjectConfigurationParticipants,
        ProjectConfigurationChanges,
        ProjectConfigurationComments,
        ProjectConfigurationObjectList,
    },
    data() {
        return {
            project: {},
            showBackground: false,
            showLayout: false,
            saving: false,
            activeTab: 'INFORMATION',
        };
    },
    props: {
        items: { type: Array, default: [] },
    },
    computed: {
        enterClass() {
            return this.showBackground
                ? 'animated slideInRight'
                : 'animated slideInLeft';
        },
        showConfiguration() {
            return this.$store.getters['Project/showConfiguration'];
        },
        showPrivacy() {
            return this.$store.getters['Project/showPrivacy'];
        },
        showParticipants() {
            return this.$store.getters['Project/showParticipants'];
        },
        showChanges() {
            return this.$store.getters['Project/showChanges'];
        },
        showComments() {
            return this.$store.getters['Project/showComments'];
        },
        projectSource() {
            return this.$store.getters.project;
        },
        hasAdminPermission() {
            return this.$store.getters.project.accessLevel == 'administrator';
        },
        hasEditPermission() {
            return this.$store.getters.project.accessLevel == 'edit';
        },
        canEdit() {
            return this.hasAdminPermission || this.hasEditPermission;
        },
        hasChanges() {
            if (this.showComments || this.showChanges) {
                return false;
            }
            return !_.isEqual(this.project, this.$store.state.project);
        },
        canManageGroups() {
            return this.$store.getters.canManageGroups;
        },
        cardSize() {
            return this.$store.getters['Project/cardSize'];
        },
        showObjectList() {
            return this.$store.getters['Project/showObjectList'];
        },
    },
    watch: {
        projectSource: {
            handler: function () {
                this.project = JSON.parse(JSON.stringify(this.projectSource));
            },
            immediate: true,
        },
    },
    methods: {
        changeCardSize(size) {
            let updatedLayout = {
                ...this.project.layout,
                ...{ cardSize: size },
            };
            this.project = { ...this.project, ...{ layout: updatedLayout } };
            this.$store.dispatch('Project/changeCardSize', size);
        },
        changeProjectLayout(layout) {
            let updatedLayout = { ...this.project.layout, ...{ type: layout } };
            this.project = { ...this.project, ...{ layout: updatedLayout } };
            this.$store.dispatch('Project/changeProjectLayout', layout);
        },
        saveChanges() {
            console.log('saving changes', this.project);
            this.$store
                .dispatch('updateProject', {
                    id: this.project._id,
                    project: this.project,
                })
                .then(() => {
                    this.$store.dispatch('Project/hideMenu');
                });
        },
    },
};
</script>

<style scoped>
.is-overflow-hidden {
    overflow: hidden;
}
.zindex1 {
    z-index: 1;
}
</style>
